import { useEffect, useRef, useState } from 'react';

function useCountUp(target: number, duration: number, active: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [active, target, duration]);
  return count;
}

const checkItems = [
  'High Level Of Security',
  'Bringing Reality To Vision',
  'Fantasy Bonus',
  'Anytime, Anywhere at PNGGO',
];

function CounterBlock({ label, value, suffix, active }: { label: string; value: number; suffix: string; active: boolean }) {
  const count = useCountUp(value, 2000, active);
  return (
    <div className="text-center">
      <div className="text-[#B80E28] text-4xl font-bold">
        {count}<span className="text-2xl">{suffix}</span>
      </div>
      <div className="text-white/60 text-xs mt-1">{label}</div>
    </div>
  );
}

export default function PlayFeaturesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setActive(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-[#111] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12">
          {/* Left — on mobile, image column is shown first via order */}
          <div className="flex-1 w-full order-2 lg:order-1">
            <p className="text-[#B80E28] text-xs font-semibold tracking-widest uppercase mb-2">Features</p>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-5">
              Play PNGGO Real-Money Betting Games Online
            </h2>
            <p className="text-white/60 text-sm leading-7 mb-6">
              PNGGO is a <strong className="text-white">trusted mobile casino for Papua New Guinea</strong> — focused on what PNG players love:{' '}
              <strong className="text-white">slots</strong>,{' '}
              <strong className="text-white">live dealer tables</strong>, and{' '}
              <strong className="text-white">sports</strong>. Top providers, fair play, strong promos, and support that gets the local scene.
            </p>
            <ul className="flex flex-col gap-3 mb-8">
              {checkItems.map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white/80 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center bg-[#B80E28]/20 rounded-full flex-shrink-0">
                    <i className="fas fa-check text-[#B80E28] text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            {/* Counters */}
            <div ref={ref} className="grid grid-cols-3 gap-4 bg-[#1a1a1a] rounded-xl p-6 border border-white/5">
              <CounterBlock label="Average Deposit Time" value={60} suffix="sec" active={active} />
              <CounterBlock label="Average Withdrawal Time" value={90} suffix="sec" active={active} />
              <CounterBlock label="Cooperative Gaming Platform" value={30} suffix="" active={active} />
            </div>
          </div>

          {/* Right */}
          <div className="flex-1 w-full flex justify-center order-1 lg:order-2">
            <img
              src="https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/f2521e6e4a2f96521a2ce3ba94c8a401.png"
              alt="Happy Players Enjoying PNGGO Casino Games"
              className="mx-auto h-auto w-auto max-h-[200px] max-w-[220px] object-contain sm:max-h-[280px] sm:max-w-xs md:max-h-none md:max-w-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
